import type { FileData } from "../types/FileData"
import { length } from "@pdfking/rfunc"

export default (filename: string): Omit<FileData, "meta"> => {
  const folders = filename.split("/")
  const parts = folders.pop()!.split(".")
  const ext = length(parts) > 1 ? parts.pop()! : ""

  return {
    basename: parts.join("."),
    ext,
    folder: `${folders.join("/")}/`,
  }
}
